import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

/**
 * @method post - move to a destination folder
 * @method delete - move to root folder (destinationFolderId is null)
 */

export const useMoveProjectsAndFoldersMutation = (options) => {
  const handleMutation = async ({
    projectIds = [],
    folderIds = [],
    destinationFolderId = null
  }) => {
    const method = destinationFolderId ? 'post' : 'delete'

    const config = {
      method,
      data: {
        folders: folderIds,
        entities: projectIds
      }
    }

    const { data } = await api(
      `/api/v2/projects/folders${destinationFolderId ? `/${destinationFolderId}` : ''}`,
      config
    )

    return data
  }

  const invalidateRelatedQueries = () => {
    return customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
  }

  return useMutation({
    mutationKey: [projectMutationKeys.MOVE_PROJECT_AND_FOLDERS],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: async (data, variables, context) => {
      await invalidateRelatedQueries()
      await options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
